import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitColumnsExtensionInterface } from '../../../extension/interface/benefit-columns.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { CouponsV2BenefitActivationDialogExtension } from './extension/coupons_v2-benefit-activation-dialog.extension';
import { CouponsV2BenefitColumnsExtension } from './extension/coupons_v2-benefit-columns.extension';
import { CouponsV2BenefitMetadataExtension } from './extension/coupons_v2-benefit-metadata.extension';
import { CouponsV2BenefitNavigationExtension } from './extension/coupons_v2-benefit-navigation.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('coupons_v2')
    .add(BenefitMetadataExtensionInterface, new CouponsV2BenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new CouponsV2BenefitNavigationExtension())
    .add(BenefitColumnsExtensionInterface, new CouponsV2BenefitColumnsExtension())
    .add(BenefitActivationDialogExtensionInterface, new CouponsV2BenefitActivationDialogExtension())
    .build(),
);
